import { Directive, HostBinding } from '@angular/core';

@Directive({ selector: '[mriMasterDetailSection]', standalone: true })
export class MasterDetailSectionDirective {
  @HostBinding('class.mri-mh-large') readonly hostClass = true;
}
